<template>
  <v-card class="afrus-d-rounded-card">
    <v-card-title>
      <v-flex xs10 class="title" pl-4>{{ $t('profile.options.personal_info') }}</v-flex>
      <v-flex xs2 class="text-xs-right">
        <v-btn color="#02579b" rounded dark @click="openProfileEditor">
          {{ $t('general.edit') }}
        </v-btn>
      </v-flex>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container>
        <v-layout wrap>
          <v-flex xs5>
            <v-layout wrap>
              <v-flex xs4>
                <v-avatar color="purple lighten-3" size="70">
                  <span class="white--text headline">
                    {{ `${user.first_name[0]}${user.last_name[0]}` }}
                  </span>
                </v-avatar>
              </v-flex>
              <v-flex xs8 mt-1>
                <span class="subheading font-weight-black">
                  {{
                    `${
                      user.treatment === 1
                        ? $t('profile.profile.people.treatment.mrs')
                        : $t('profile.profile.people.treatment.mr')
                    } ${user.first_name} ${user.last_name}`
                  }}
                </span>
                <br />
                <span class="caption grey--text text--darken-2">
                  {{ $t('profile.profile.created_at') }}
                  {{ user.created_at | moment('DD/MM/YYYY') }}
                </span>
                <br />
                <span
                  class="caption font-weight-black"
                  :class="[
                    user.status ? 'green--text text--accent-4' : 'red--text text--accent-4'
                  ]"
                >
                  {{
                    (user.status
                      ? $t('profile.profile.active')
                      : $t('profile.profile.inactive')
                    ).toUpperCase()
                  }}
                </span>
              </v-flex>
              <v-flex xs12 ml-4 pt-4>
                <span class="blue--text text--darken-4 font-weight-black">
                  {{ $t('profile.profile.email') }}
                </span>
                <br />
                <span class="grey--text text--darken-1 font-weight-black">{{ user.email }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs4>
            <v-layout wrap>
              <v-flex xs12 pt-4>
                <span class="blue--text text--darken-4 font-weight-black">
                  {{ $t('profile.profile.language') }}
                </span>
              </v-flex>
              <v-flex xs12>
                <span class="grey--text text--darken-1 font-weight-black">{{ language }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs2>
            <v-layout wrap>
              <v-flex xs12 pt-4>
                <span class="blue--text text--darken-4 font-weight-black">
                  {{ $t('profile.profile.gender') }}
                </span>
              </v-flex>
              <v-flex xs12>
                <span class="grey--text text--darken-1 font-weight-black">
                  {{
                    user.gender === 'F'
                      ? $t('profile.profile.people.gender.female')
                      : $t('profile.profile.people.gender.male')
                  }}
                </span>
              </v-flex>
              <v-flex xs12 pt-4>
                <span class="blue--text text--darken-4 font-weight-black">
                  {{ $t('profile.profile.phone') }}
                </span>
              </v-flex>
              <v-flex xs12>
                <span class="grey--text text--darken-1 font-weight-black">
                  {{ user.phone }}
                </span>
              </v-flex>
              <v-flex xs12 pt-4>
                <span class="blue--text text--darken-4 font-weight-black">
                  {{ $t('profile.profile.timezone') }}
                </span>
              </v-flex>
              <v-flex xs12 pb-5>
                <span class="grey--text text--darken-1 font-weight-black">
                  {{ user.time_zone }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import moment from 'moment-timezone'
import languages from '@/data/languages.json'
export default {
  name: 'AccountProfile',
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      getProfile: 'auth/getProfile'
    }),
    ...mapMutations({
      changeProfileEditor: 'auth/changeProfileEditor',
      editorProfileDrawer: 'auth/editorProfileDrawer'
    }),
    openProfileEditor () {
      let toEdit = JSON.parse(JSON.stringify(this.user))
      this.changeProfileEditor(toEdit)
      this.editorProfileDrawer(true)
    }
  },
  computed: {
    ...mapState({
      user: ({ auth: { user } }) => user
    }),
    language() {
      if (!this.user.language_code) return ''
      const { language_code } = this.user
      return languages.find(e => e.code === language_code.toLowerCase()).name
    }
  }
}
</script>

<style>

</style>
